'use strict'

import { apiInstance, legacyV2 } from './index'
// import { mapArgs } from 'utils/functions'
import { mapArgs, sanitizeCostCenters } from 'utils/functions'

const employee = {
  getEmployeesList (limit, page) {
    return apiInstance
      .get(`${legacyV2()}/employee`, {
        params: {
          limit,
          page
        }
      })
  },

  getEmployeeById (employeeId) {
    return apiInstance
      .get(`${legacyV2()}/employee/${employeeId}`)
  },

  getEmployees (...args) {
    const params = mapArgs(...args)

    return apiInstance
      // .get('/employee', {
      .get(`${legacyV2()}/employee`, {
        params
      })
  },

  exportEmployees (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      // url: `${legacyV2()}/employee/export`,
      url: `/b2b-legacy-report/employee/export`,
      timeout: 10 * 60000,
      responseType: 'blob',
      params
    })
  },

  deleteEmployee (employeeId) {
    return apiInstance
      .delete(`${legacyV2()}/employee/${employeeId}`)
  },

  addToAllCostCenters (employeeId) {
    return apiInstance
      .put(`${legacyV2()}/employee/${employeeId}/addToAllCostCenters`, {
        id: String(employeeId)
      })
  },

  applyCategoryToAll (companyIds, categoryIds) {
    return apiInstance
      .put(`${legacyV2()}/employee/batchCategories`, {
        companyIds,
        categoryIds
      })
  },

  addEmployee (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/employee`,
      data
    })
  },

  editEmployee2 (data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2()}/employee/${data.id}`,
      data
    })
  },

  editEmployee (budget, budgetDate, budgetPeriod, costCenters, credit, employee, useBudget, useRideCredit, isNew) {
    const costCentersSanitized = sanitizeCostCenters(costCenters)
    let method
    let url = `${legacyV2()}/employee`

    // this is seriously the worst payload i've seen in my entire life
    // budget, budgetDate, budgetPeriod, credit and employee.budgetLimit are all related
    // to credit policy yet they're sent like this.

    // budget = {date, period}
    // budgetDate = 14/02/2019
    // budgetPeriod = 'date'

    let params = {
      budget,
      budgetDate,
      budgetPeriod,
      costCenters: costCentersSanitized,
      credit,
      employee,
      useBudget,
      useRideCredit
    }

    if (isNew) {
      method = 'post'
      params.new = true
    } else {
      method = 'put'
      url = `${url}/${employee.id}`
    }

    return apiInstance({
      method,
      url,
      data: params
    })
  },

  resendWelcomeEmail (employeeId) {
    return apiInstance
      .post(`${legacyV2()}/employee/${employeeId}/resendWelcomeEmail`)
  },

  addEmployeesBulk (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/employee/wizard`,
      data
    })
  },

  sendSms (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/employee/wizard/phoneNumbers`,
      data
    })
  },

  searchEmployeePhone (phone) {
    return apiInstance({
      methos: 'GET',
      url: `${legacyV2()}/employee/phone/${phone}`
    })
  }
}

export default employee
